/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IHeader, IMapViewProps } from './map-custom';

const MapHeader: React.FC<IHeader> = ({ headerProps, heading }) => <Node {...headerProps}>{heading}</Node>;

const MapView: React.FC<IMapViewProps> = ({ ModuleProps, Header, MapProps }) => (
    <Module {...ModuleProps}>
        {Header && <MapHeader {...Header} />}
        <Node {...MapProps} />
    </Module>
);

export default MapView;
